import React from "react";
import DataTable from "../../../shared/components/DataTable";
import { FlexContainer } from "../../../shared/components/styled/Container.styled";
import PaymentActivityCell from "../../../shared/components/table/PaymentActivityCell";
import { useTheme } from "@mui/styles";
import { useMediaQuery } from "@mui/material";

const DashboardPaymentActivity = ({
  headers = [],
  rows = [],
  emptyDataMessage = "",
  rowAttributes = [],
  inActiveOrDeadLoan = false,
}) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const isTablet = useMediaQuery(theme.breakpoints.down("md"));

  return (
    <FlexContainer 
      width={isMobile ? "100%" : isTablet ? "100%" : "70%"} 
      alignself="flex-start" 
      padding={isMobile ? "0" : isTablet ? "0 0 0 30px" : "0 0 0 50px"}
    >
      {!inActiveOrDeadLoan ? (
        <DataTable
          headers={headers}
          rows={rows}
          emptyDataMessage={emptyDataMessage}
          rowAttributes={rowAttributes}
          CellDisplayComponent={PaymentActivityCell}
          minWidth={isMobile ? "300px" : isTablet ? "400px" : "500px"}
        />
      ) : ""}
    </FlexContainer>
  );
};

export default DashboardPaymentActivity;